import { Link } from 'react-router-dom';
import styles from './notFound.module.css';

const NotFound = () => {
    return (
        <section className={styles.notFound}>
            <div className='pageContainer'>
                <div className={styles.notFoundContainer}>
                    <Link to="/">
                        <img
                            className={styles.notFoundLogo}
                            src={process.env.PUBLIC_URL + `/assets/imgs/Logo.svg`}
                            alt="LogoImage"
                        />
                    </Link>
                    <div className={styles.notFoundContent}>
                        The requested page is not available.
                    </div>
                </div>
            </div>
        </section>
    )
}

export default NotFound;
